import { brandPrimary } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

export const CompleteCheckIcon = ({
	strokeColor = brandPrimary,
	fillColor = brandPrimary,
	width = 121,
	height = 120,
}: {
	strokeColor?: string;
	fillColor?: string;
	width?: number;
	height?: number;
}) => {
	return (
		<SvgIcon width={width} height={height} viewBox='0 0 121 120'>
			<g fill='none' fillRule='evenodd'>
				<g transform='translate(1.514 1.24)'>
					<ellipse
						cx='58.785'
						cy='58.88'
						fill={fillColor}
						fillOpacity='.047'
						stroke={strokeColor}
						strokeWidth='2'
						rx='58.785'
						ry='58.88'
					/>
					<ellipse cx='58.785' cy='58.88' fill='#FFF' rx='51.869' ry='51.953' />
				</g>
				<path fill='#06F' d='M56.887 76 43 62.179l6.071-6.044 6.721 6.69L70.015 43 77 47.964z' />
			</g>
		</SvgIcon>
	);
};
